import { Popover, Space, Tag } from 'antd'
import React from 'react'

function LedgerAuditTag(props) {
    return (
        <Popover content={<Space direction='vertical'>
            {props.ebn_audit_uname && <Tag color='green'>1级{props.ebn_audit_uname} {props.ebn_audit_ctime} </Tag>}
            {props.ebn_audit2_uname && <Tag color='geekblue'>2级{props.ebn_audit2_uname} {props.ebn_audit2_ctime} </Tag>}
            {props.ebn_audit3_uname && <Tag color='gold'>3级{props.ebn_audit3_uname} {props.ebn_audit3_ctime} </Tag>}
            {props.ebn_audit4_uname && <Tag color='magenta'>4级{props.ebn_audit4_uname} {props.ebn_audit4_ctime} </Tag>}
        </Space>}>
            {(props.ebn_audit_uname && !props.ebn_audit2_uname) &&   <Tag color='green'>1级{props.ebn_audit_uname}</Tag>}
            {(props.ebn_audit2_uname && !props.ebn_audit3_uname) && <Tag color='geekblue'>2级{props.ebn_audit2_uname}</Tag>}
            {(props.ebn_audit3_uname && !props.ebn_audit4_uname) && <Tag color='gold'>3级{props.ebn_audit2_uname}</Tag>}
            {props.ebn_audit4_uname && <Tag color='magenta'>4级{props.ebn_audit2_uname}</Tag>}
        </Popover>
    )
}

export default LedgerAuditTag